export default __webpack_public_path__ + "static/media/enertech-logo.3120ca6f.png";